import FormField from 'components/form-field/form-field';
import { CountryCode } from 'modules/company/types/company.type';
import React, { FunctionComponent, useMemo } from 'react';

type Props = {
  isDisabled: boolean;
  countryCode: CountryCode;
  onBlur?: () => void;
};

export const RegistrationNumberField: FunctionComponent<Props> = ({
  isDisabled,
  countryCode,
  onBlur,
}) => {
  const { label, helpText } = useMemo(() => {
    switch (countryCode) {
      case CountryCode.FR:
        return {
          label: 'Siret',
          helpText: 'Le SIRET est composé de 14 chiffres',
        };

      case CountryCode.BE:
        return {
          label: "Numéro d'entreprise",
          helpText: "Le numéro d'entreprise est composé de 10 chiffres",
        };
    }
  }, [countryCode]);

  return (
    <FormField
      disabled={isDisabled}
      name="registrationNumber"
      type="text"
      helpText={helpText}
      label={label}
      required
      onBlur={onBlur}
    />
  );
};
